export { default } from './Timeline';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Timeline/index.js
// module id = 894
// module chunks = 2